import React, { useState } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
/* FN: GridToolbar will be removed in MUI 
V9 version so it needs to be updated.
*/
import CustomButton from '../Button/Button';
import DeleteConfirmationModal from '../Modal/deleteConfirmationModal';
import './Table.scss'

const DefaultTable = ({
  rows,
  columns,
  pageSizeOptions = [5, 10],
  onRowSelectionChange,
  deleteBtnProps = {},
  withToolbar = true,
  csvFileName = 'VFlow',
  tableWrapperProps = {},
  ...rest
}) => {
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteClick = () => {
    setDeleteModalOpen(true);
  };

  const handleCloseModal = () => {
    setDeleteModalOpen(false);
  };

  const handleConfirmDelete = () => {
    if (deleteBtnProps.onClick) {
      deleteBtnProps.onClick();
    }
    setDeleteModalOpen(false);
  };

  const { onClick, ...restDeleteBtnProps } = deleteBtnProps;

  return (
    <div style={{ height: 500, width: '100%' }} {...tableWrapperProps}>
      <DataGrid
        getRowId={(row) => row._id}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: {
              allColumns: true,
              fileName: csvFileName,
              disableToolbarButton: !rows || rows.length === 0
            },
          
          },
          pagination: {
            slotProps: {
              select: {
                name: 'pageSize',
              },
            },
          },
          baseCheckbox: {
            name: 'table-checkbox',
          },
        }}
        slots={{
          toolbar: (props) => (
              <div
                style={{
                  display: 'flex',
                  justifyContent: withToolbar ? 'space-between' : 'flex-end',
                  marginBottom: '8px',
                }}
              >
                {withToolbar && <GridToolbar {...props} />}
                <CustomButton
                  buttonType="delete"
                  onClick={handleDeleteClick}
                  {...restDeleteBtnProps}
                />
              </div>
            ),
        }}
        rows={rows}
        columns={columns}
        pageSizeOptions={pageSizeOptions}
        checkboxSelection
        disableRowSelectionOnClick
        onRowSelectionModelChange={onRowSelectionChange}
        {...rest}
      />
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModal}
        onDelete={handleConfirmDelete}
        message={deleteBtnProps.msg || ''}
      />
    </div>
  );
};

export default DefaultTable;
